import { render, staticRenderFns } from "./StudentGradeView.vue?vue&type=template&id=7d0df3f5&scoped=true"
import script from "./StudentGradeView.vue?vue&type=script&lang=js"
export * from "./StudentGradeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0df3f5",
  null
  
)

export default component.exports